import ClientAssetModule from "../assets/ClientAssetModule";
import type { ClientAssetModuleProps } from "../assets/ClientAssetModule";
import theme from "./LifeRaft.module.css";

type Props = Omit<ClientAssetModuleProps, "type" | "themeClassName">;

export default function LifeRaftPage(props: Props) {
  return (
    <ClientAssetModule
      {...props}
      type="Life Raft"
      themeClassName={theme.theme}
    />
  );
}
